module.exports = __webpack_public_path__ + "static/media/contactInfo.392a9d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/app-composer/concierge/images/contactInfo.png
// module id = 595
// module chunks = 0